// src/utils/runResults.js
//
// The ONE mapping from a run's backend payload to the `results` of a generator
// history entry. Two sources, one shape:
//   resultsFromRunContent — GET /pipeline/run/{id}/content (useGeneration)
//   resultsFromRunDetail  — GET /pipeline/run/{id} → result_json (RunDetailPage,
//                           RunDetailModal; their «Ricarica» / «Modifica» hand the
//                           entry to the generator)
// `verification` / `sourcesConsulted` (BE ≥ e162398): null for pinterest/youtube,
// and for runs stored before them — /content sends null, result_json lacks the
// keys; both read as null here, which means "no claims panel". The removed keys
// `reviews` / `sources` are not carried: nothing renders them any more (the
// superadmin JSON disclosures read result_json directly).

const objectOrNull = (v) => (v && typeof v === 'object' && !Array.isArray(v) ? v : null);
const arrayOrNull = (v) => (Array.isArray(v) ? v : null);

export function resultsFromRunContent(taskId, runContent, runStatus) {
  return {
    _taskId: taskId,
    content: runContent.content,
    contentFormat: runContent.content_format || null,
    platform: runContent.platform,
    topic: runContent.topic,
    factualConfidence: runContent.critic_score,
    styleScore: runContent.style_score,
    status: runStatus.status,
    research: runContent.research || null,
    drafts: runContent.drafts || null,
    style: runContent.style || null,
    metadata: runContent.metadata || null,
    verification: objectOrNull(runContent.verification),
    sourcesConsulted: arrayOrNull(runContent.sources_consulted),
    warnings: runContent.warnings ?? null,
    warningsCount: runStatus.warnings_count ?? null,
  };
}

export function resultsFromRunDetail(detail) {
  const result = detail.result_json || {};
  return {
    _taskId: detail.task_id,
    content: result.content,
    contentFormat: result.content_format ?? detail.content_format ?? null,
    platform: result.platform ?? detail.platform,
    topic: result.topic ?? detail.topic,
    factualConfidence: detail.critic_score,
    styleScore: detail.style_score,
    status: detail.status,
    research: result.research || null,
    drafts: result.drafts || null,
    style: result.style || null,
    metadata: result.metadata || null,
    verification: objectOrNull(result.verification),
    sourcesConsulted: arrayOrNull(result.sources_consulted),
    warnings: result.warnings ?? null,
    warningsCount: detail.warnings_count ?? null,
  };
}
